import React from 'react';
import CancelCase from "./CancelCase";
import SplitButton from './SplitButton';
import DocTypesEnum from "../../../enums/DocTypesEnum";
import AddDocumentToCase from "./addDocumnetToCase";

const HideCasePopup = ({
                           documentTypes,
                           refreshCaseFiles,
                           documentTypesForEditor,
                           userId,
                           objectOwner,
                           users,
                           barcode,
                           caseInfo,
                           permitTypeTitle,
                           exploitationIdentificationTemplateString,
                           ownerIdentificationTemplateString,
                           permitTypeId,
                           caseData,
                           orderDepartment,
                           disabledBecauseSecretOrderExist,
                           userAddress
                       }) => {

    const renderDocumentComponent = (doc) => {
        switch (doc.documentTypeStatus) {
            case DocTypesEnum.makeCaseSecret.id:
                return (
                    <AddDocumentToCase
                        onFileAdded={refreshCaseFiles}
                        documentTypes={documentTypesForEditor}
                        permitTypeId={permitTypeId}
                        docType={doc}
                        buttonTitle={doc.name}
                        userId={userId}
                        barcode={barcode}
                        caseData={caseData}
                        disabledBecauseOfDeclinedFiles={false}
                        caseInfo={caseInfo}
                        users={users}
                        objectOwner={objectOwner}
                        hasOrderDate={false}
                        isSecretOrder={true}
                        orderDepartment={orderDepartment}
                        permitTypeTitle={permitTypeTitle}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        disabledBecauseSecretOrderExist={disabledBecauseSecretOrderExist}
                        userAddress={userAddress}

                    />
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <SplitButton
                options={documentTypes}
                renderDocumentComponent={renderDocumentComponent}
                buttonLabel="საპროექტო დოკუმენტაციის გასაიდუმლოება"
                buttonType={3}
            />
        </div>
    );
};

export default HideCasePopup;
